module.exports = __webpack_public_path__ + "static/media/carousel_intro.d9d0bfdf.gif";